<template>
  <b-modal size="sm" v-model="showModal" centered title="Gruppenmitglieder" @hidden="$emit('hide-group')"
  >
    <b-row class="mt-2">
      <b-col>
        <div v-for="item in roomUsers" :key="item" style="padding: 4px;">
          {{ item }}
        </div>
      </b-col>
    </b-row>
    <template #modal-footer="{ok}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="showModal = false">
        Ok
      </b-button>
    </template>
  </b-modal>

</template>

<script>
export default {
  name: "task_messaging_user",
  props: {
    users: Array,
    showGroup: Boolean,
  },
  data() {
    return {
      showModal: false,
    }
  },
  watch: {
    showGroup: function(newVal, oldVal) { // watch it
      if (this.showModal !== newVal) {
        this.showModal = newVal;
      }
    }
  },
  computed: {
    roomUsers() {
      let res = [];
      if (!this.users || !this.users.length) {
        return res;
      }
      for (let i = 0; i < this.users.length; i++) {
        let parsed = JSON.parse(sessionStorage.getItem(this.users[i]._id))
        if (parsed !== null) {
          res.push(parsed.full_name);
        }
      }
      //sort the room users
      res.sort((a, b) => {
        const nameA = a.toUpperCase(); // ignore upper and lowercase
        const nameB = b.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      return res;
    }
  },
}
</script>

<style scoped>

</style>
